import { Checkbox, FormControlLabel, FormControlLabelProps } from "@mui/material";
import { Controller, FieldValues, Path, useFormContext } from "react-hook-form";

export type FormCheckBoxValue = boolean;

export type FormCheckBoxProps<TFormValues extends FieldValues> = Omit<
  FormControlLabelProps,
  "name" | "control" | "defaultValue"
> & {
  name: Path<TFormValues>;
};

export function FormCheckBox<TFormValues extends FieldValues>({
  name,
  label,
  ...rest
}: FormCheckBoxProps<TFormValues>) {
  const { control } = useFormContext<TFormValues>();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          name={field.name}
          checked={field.value}
          label={label}
          control={<Checkbox size="small" />}
          labelPlacement="start"
          {...rest}
        />
      )}
    />
  );
}
